export enum ENav {
  PERSONAL = "PERSONAL",
  BUSINESS_UNIT = "BUSINESS_UNIT",
  CORPORATION = "CORPORATION",
  COMMUNITY = "COMMUNITY",
  SEARCH = "SEARCH",
  KENSAKU_KUN = "KENSAKU-KUN",
}

export enum EPersonal {
  SUPERADMIN = "SUPERADMIN",
  EMPLOYEE = "EMPLOYEE",
  EMPLOYEE_OWN = "EMPLOYEE_OWN",
  STAFF = "STAFF",
  CLIENT = "CLIENT",
}

export enum EBusinessUnit {
  ASSIGNMENT = "ASSIGNMENT",
}

export type TNavChild = Omit<
  TNavItem,
  | "name"
  | "showShowMore"
  | "children"
  | "childrenOpened"
  | "hrefShowMore"
  | "icon"
>;

export type TNavItem = {
  name: ENav;
  label: string;
  href: string;
  icon: React.ReactNode;
  showShowMore?: boolean;
  superAdminOnly?: boolean;
  hrefShowMore?: string;
  children?: TNavChild[];
  childrenOpened?: boolean;
};

export enum ENavTab {
  GENERAL_SETTING = "GENERAL_SETTING",
  STAFF = "STAFF",
  EMPLOYEE = "EMPLOYEE",
  CLIENT = "CLIENT",
  MEMBER = "MEMBER",
  EMPLOYED_CORPORATION = "EMPLOYED_CORPORATION",
  MY_ROLE = "MY_ROLE",
  CORPORATION_DETAIL = "CORPORATION_DETAIL",
  EMPLOYED_STAFF = "EMPLOYED_STAFF",
  ACTIVE_VACANCIES = "ACTIVE_VACANCIES",
  MANAGE_POSTINGS = "MANAGE_POSTINGS",
  ASSIGNED_ACCOUNTS = "ASSIGNED_ACCOUNTS",
  MANAGE_MEMBERS_ASSIGNMENT = "MANAGE_MEMBER_ASSIGNMENT",
  UNASSIGNED_ACCOUNTS = "UNASSIGNED_ACCOUNTS",
  BUSINESS_ESTABLISHMENTS = "BUSINESS_ESTABLISHMENTS",
  PERSONAL_ACCOUNT = "PERSONAL_ACCOUNT",
  BUSINESS_UNIT = "BUSINESS_UNIT",
  CORPORATION = "CORPORATION",
  COMMUNITY = "COMMUNITY",
  EVALUATE = "EVALUATE",
  MANAGE_TAGS = "MANAGE_TAGS",
  SEARCH_STAFF = "SEARCH_STAFF",
  SEARCH_EMPLOYEE = "SEARCH_EMPLOYEE",
  PAST_NOTES = "PAST_NOTES",
  SEARCH_CLIENT = "SEARCH_CLIENT",
  SEARCH_CORPORATION = "SEARCH_CORPORATION",
  SEARCH_JOB_LISTING = "SEARCH_JOB_LISTING",
  SCORECARD_HISTORY = "SCORECARD_HISTORY",
}

export type TStaticChildNav = {
  name: string;
  slug: string;
};
